
export const totalFollowersConfig: StatCardConfig = {
  id: "followers",
  title: "Total Followers",
  value: "4,562",
  change: "+23% last month",
  changeColor: "text-pink",
  bg: "bg-pink-soft",
  iconColor: "text-pink",
  iconBg: "bg-pink-icon",
  chartColor: "#ff5a87",
  chartType: "bar",
  chartData: [
    { v: 30 },
    { v: 45 },
    { v: 35 },
    { v: 60 },
    { v: 50 },
    { v: 70 },
    { v: 55 },
  ],
};
